import React from 'react';
interface StatCardProps {
  title: string;
  value: string | number;
  icon?: ReactNode;
  trend?: {
    value: number;
    isPositive: boolean;
  };
  onClick?: () => void;
  className?: string;
}
export function StatCard({
  title,
  value,
  icon,
  trend,
  onClick,
  className = ''
}: StatCardProps) {
  return <div onClick={onClick} className={`
        bg-white rounded-lg border border-gray-200 shadow-sm p-6
        ${onClick ? 'cursor-pointer' : ''}
        ${className}
      `} data-id="element-249">
      <div className="flex items-start justify-between" data-id="element-250">
        <div className="flex-1" data-id="element-251">
          <p className="text-sm font-medium text-gray-500" data-id="element-252">{title}</p>
          <p className="mt-2 text-3xl font-bold text-gray-900" data-id="element-253">{value}</p>
          {trend && <p className={`mt-2 text-sm font-medium ${trend.isPositive ? 'text-green-600' : 'text-red-600'}`} data-id="element-254">
              {trend.isPositive ? '↑' : '↓'} {Math.abs(trend.value)}%
            </p>}
        </div>
        {icon && <div className="p-3 bg-blue-50 rounded-lg text-blue-600" data-id="element-255">{icon}</div>}
      </div>
    </div>;
}